import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("ascend-platform-token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const setAuthSession = (payload) => {
  localStorage.setItem("ascend-platform-token", payload.token);
  localStorage.setItem("ascend-platform-role", payload.role);
  localStorage.setItem("ascend-platform-name", payload.full_name);
};

export const clearAuthSession = () => {
  localStorage.removeItem("ascend-platform-token");
  localStorage.removeItem("ascend-platform-role");
  localStorage.removeItem("ascend-platform-name");
};

export const getStoredRole = () => localStorage.getItem("ascend-platform-role");
export const getStoredToken = () => localStorage.getItem("ascend-platform-token");

export const downloadProtectedFile = async (downloadPath, fileName) => {
  const response = await api.get(downloadPath, { responseType: "blob" });
  const blobUrl = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement("a");
  link.href = blobUrl;
  link.setAttribute("download", fileName || "download");
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(blobUrl);
};

export { BACKEND_URL };